import { useEffect, useState } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";
import { ProviderOption } from "../../../../../data-model/providerOptionModel";
import { ModalId } from "../../../../../enums/modalId";

interface DeleteProviderOptionConfirmProps {
  option: ProviderOption | null;
  onDelete: (option: ProviderOption) => Promise<void>;
  onClose: () => void;
}

const DeleteProviderOptionConfirm = ({
  option,
  onDelete,
  onClose,
}: DeleteProviderOptionConfirmProps) => {
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (option) {
      openModal(ModalId.DELETE_PROVIDER_OPTION_CONFIRM);
    }
  }, [option]);

  const handleConfirm = async () => {
    if (!option) return;
    setDeleting(true);
    try {
      await onDelete(option);
    } finally {
      setDeleting(false);
      closeModal(ModalId.DELETE_PROVIDER_OPTION_CONFIRM);
      onClose();
    }
  };

  const handleCancel = () => {
    if (deleting) return;
    closeModal(ModalId.DELETE_PROVIDER_OPTION_CONFIRM);
    onClose();
  };

  if (!option) return null;

  return (
    <Modal
      dialogId={ModalId.DELETE_PROVIDER_OPTION_CONFIRM}
      title="Delete Provider Option"
      saveButtonText={deleting ? "Deleting..." : "Yes, Delete"}
      cancelText="Cancel"
      onSave={handleConfirm}
      onCancel={handleCancel}
      onClose={handleCancel}
      disableSave={deleting}
      autoCloseOnSave={false}
    >
      <div className="flex flex-col items-center justify-center gap-3 py-2">
        <div className="text-center text-sm text-primaryGray-3">
          Are you sure you want to delete{" "}
          <span className="font-semibold">{option.name}</span>? This action
          cannot be undone.
        </div>
      </div>
    </Modal>
  );
};

export default DeleteProviderOptionConfirm;
